var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceTour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.787,
    height: 59.255,
    viewBox: "0 0 58.787 59.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38796",
    "data-name": "\\uADF8\\uB8F9 38796",
    transform: "translate(-428.713 -1577.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38759",
    "data-name": "\\uADF8\\uB8F9 38759",
    transform: "translate(429.913 1577.265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_60",
    "data-name": "\\uC0AC\\uAC01\\uD615 60",
    width: 52.753,
    height: 7.05,
    rx: 3.525,
    transform: "translate(0 21.085)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19493",
    "data-name": "\\uD328\\uC2A4 19493",
    d: "M9.054,0",
    transform: "translate(22.359 0)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_40",
    "data-name": "\\uADF8\\uB8F9 40",
    transform: "translate(461.517 1596.095)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_16",
    "data-name": "\\uC0AC\\uAC01\\uD615 16",
    width: 15.367,
    height: 12.759,
    transform: "translate(5.056 20.26)",
    fill: "none",
    stroke: "#000c7a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_17",
    "data-name": "\\uC0AC\\uAC01\\uD615 17",
    width: 24.983,
    height: 17.142,
    rx: 2,
    transform: "translate(0 20.26)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_17",
    "data-name": "\\uD328\\uC2A4 17",
    d: "M736.655,1930.772v-1.867a1.906,1.906,0,0,0-1.9-1.9h-3.677a1.906,1.906,0,0,0-1.9,1.9v1.867",
    transform: "translate(-720.425 -1911.314)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_11",
    "data-name": "\\uC120 11",
    y2: 17.142,
    transform: "translate(20.423 20.26)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_12",
    "data-name": "\\uC120 12",
    y2: 17.142,
    transform: "translate(4.56 20.26)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_18",
    "data-name": "\\uC0AC\\uAC01\\uD615 18",
    width: 6.749,
    height: 2.72,
    rx: 1.36,
    transform: "translate(9.117 24.441)",
    fill: "#f09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19",
    "data-name": "\\uD328\\uC2A4 19",
    d: "M696.9,2041.693a1.941,1.941,0,1,0,3.881,0",
    transform: "translate(-678.418 -2004.209)",
    fill: "#f09",
    stroke: "#000c7a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_20",
    "data-name": "\\uD328\\uC2A4 20",
    d: "M780.378,2041.693a1.941,1.941,0,1,0,3.882,0",
    transform: "translate(-777.758 -2004.209)",
    fill: "#f09",
    stroke: "#000c7a",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceTour);
export default __webpack_public_path__ + "static/media/icon-service-tour.3031c85fa10538d49514f7c226437ef8.svg";
export { ForwardRef as ReactComponent };